import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import { useIntl } from "react-intl";
import { useAuth } from "../providers/AuthProvider";
import { fetchCompany } from "../api/memberApi";

export default function HomePage() {
  const intl = useIntl();
  const { member, companyId } = useAuth();
  const t = (id) => intl.formatMessage({ id });

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  const fullName =
    member?.fullName ||
    `${member?.firstName || ""} ${member?.lastName || ""}`.trim() ||
    "";

  useEffect(() => {
    if (!companyId) return;
    setLoading(true);
    fetchCompany(companyId)
      .then((data) => setCompany(data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, [companyId]);

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
        {t("home.title")}
      </Typography>

      {fullName && (
        <Typography variant="body1" sx={{ mb: 1 }}>
          {fullName}
        </Typography>
      )}

      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <>
          {company?.purpose && (
            <Paper variant="outlined" sx={{ p: 3, mt: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                {t("tree.companyValues")}
              </Typography>
              <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
                {company.purpose}
              </Typography>
            </Paper>
          )}
        </>
      )}
    </Box>
  );
}
